var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
			'text-ellipsis': _vm.singleLine
		}},[(_vm.textFormatting)?_c('div',[_vm._l((_vm.linkifiedMessage),function(message){return [_vm._v(" "+_vm._s(message.value)+_vm._s(message.show)+" ")]})],2):_c('div',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }